import { PAYMENTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';
import { RouteComponent, RouteRecordRaw } from 'vue-router';

export const pspSortingRoutes: RouteRecordRaw[] = [
  {
    name: PAYMENTS_SECTIONS_ROUTES.PSP_SORTING,
    path: `/${PAYMENTS_SECTIONS_ROUTES.PSP_SORTING}`,
    component: async(): Promise<RouteComponent> =>
      await import('@/layouts/psp-sorting-page/psp-sorting-page.vue'),
  },
];
